// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__14TDD","author":"Table_author__2R_Xt","authorImage":"Table_authorImage__2aSrv","unreadRow":"Table_unreadRow__vAyVU"};